import React from 'react';

import './SecurityPolicy.scss';

function SecurityPolicy() {

  return (
    <div className="container security">
      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy document applies to the headstartcourses.ie website.It explains the manner in which we collect, use, maintain and disclose information collected from users(each, a“ Student”) of Head Start Courses.
      </p>

      <h2>Personal Data</h2>
      <p>
        We may collect personal identification information from users in a variety of ways. We will collect personal information from users only if they voluntarily submit it to us, including, but not limited to, when they subscribe to a newsletter and/or enroll a course, by shopping within Head Start Courses. 

        We may collect and use Students’ personal data for the following purposes:

        In order to facilitate communication with you and to improve customer service, by enquiry forms that will request your name, email and/or contact number. We may use Student email addresses to respond to inquiries and other requests; send documents (as the Certificate at the end of the course) and give updates about Head Start Courses.


        To buy a course, requesting the personal data (full name, e-mail, phone contact, address and card information). This is so that we can create a legal invoice and we can contact you quickly if the need arises (for example, in case a student doesn’t attend the face to face course). Please note we do not store your credit card details.

        To personalize user experience, in order to understand our Students’ experience, using the services and resources provided on the website.
      </p>

      <h2>Sharing Your Personal Information</h2>
      <p>We do not sell, trade, or rent Student personal identification information to others.</p>

      <h2>Privacy Policy Update</h2>

      <p>
        We may update this Privacy Policy at any time. You acknowledge and agree that it is your responsibility to review this Privacy Policy periodically and become aware of all updates.
      </p>

      <h2>Your Acceptance Of These Terms</h2>

      <p>
      By enrolling in Head Start Courses, you signify your acceptance of this Privacy Policy. If you do not agree to this Privacy Policy, please do not enroll in it. Your continued enrollment in Head Start Courses following the posting of changes to this Privacy Policy will be deemed your acceptance of those changes.

      When you've read this, you should be able to understand how and why we collect your personal data on this website, how long we keep it and your rights with respect to any personal data that we hold.

      If you have any question, or want to exercise your rights under the GDPR, please refer to the email supplied at the end of this document.
      </p>

      <h2>Non Personal Data Collection</h2>
      <p>
        We use Cookies for tasks on the website. Some of these are essential, such as the functionality of the shopping cart and our website software, but non-essential cookies such as Google Analytics can be turned off if you wish. 
      </p>

      <h2>How long we keep your Personal Data</h2>
      <p>
        If you are not a client, we routinely delete personal data collected from Contact forms. If you are a client, this data is held indefinitely. Bear in mind, we may hold your personal data in other systems such as our databasing and accounting software.
      </p>

      <h2>Purchases on the Website</h2>
      <p>
        If you have made a purchase on the website we keep the data you submitted indefinitely if you are an existing client. We do not store credit card data. 
      </p>

      <h2>Who we share your data with</h2>
      <p>
      Your name, address, transaction and credit card details will be shared with our payment gateway but only for the purposes of processing your payment, or in the event of a dispute with the payment processing. To understand more about Stripe's Data Protection policies please refer to https://stripe.com/ie/privacy

      Please note that while we will never share your data unless we have to, we will only do so if we believe in good faith that we are required to disclose it in order to comply with any applicable law, a summons, a search warrant, a court or regulatory order other statutory requirement.

      Your personal data may also be provided to relevant third parties in the case of our business being sold, merged or made insolvent.
      </p>

      <h2>Is your Personal Data secure?</h2>
      <p>
        Your personal data resides in the EU and is secured using the most up to date and modern technology. Bear in mind that no system is foolproof. If there's ever a breach, and we hope that never happens - you'll be notified by us in 72 hours.
      </p>

      <h2>Minors</h2>

      <p>
        You must be 16 years or older to purchase courses from our website. If you are under 16, you must get your parent's or guardian's permission before submitting personal data via enquiry forms on our website.
      </p>

      <h2>Your Rights under the General Data Protection Rules (GDPR)</h2>
      <p>
      You have the right to retrieve a copy of your personal data in machine readable format
      You have the right to transfer your data to another provider
      You have the right to request the removal of your data ("right to be forgotten")
      You have the right to request a restriction from processing your data
      You have the right to withdraw your consent to our use of personal information at any time
      You have the right to have your request dealt in 30 days of receipt.
      If you wish to exercise your rights please send details of your request along with 2 photocopies of recent bills (or similar) which show your name, your address and a date no later than 3 months from the date you sent your request to:
      bartira@headstartcourses.ie
      In case of a dispute you have the right to contact the Data Protection Authority, please see: <a href="https://www.dataprotection.ie" target="_blank">https://www.dataprotection.ie</a>
      </p>

      <br />

      <h2>Cookies Policy</h2>
      <p>
      According to the <a href="https://ec.europa.eu/info/cookies_en" target="_blank">European Commission</a>, a cookie is a small text file that a website stores on your computer or mobile device when you visit the site.

      First party cookies are cookies set by the website you’re visiting. Only that website can read them. In addition, a website might potentially use external services, which also set their own cookies, known as third-party cookies.

      Persistent cookies are cookies saved on your computer and that are not deleted automatically when you quit your browser, unlike a session cookie, which is deleted when you quit your browser.

      Every time you visit our website, you will be prompted to accept or refuse cookies.
      The purpose is to enable the site to remember your preferences (such as user name, language, etc.) for a certain period of time. That way, you don’t have to re-enter them when browsing around the site during the same visit. Cookies can also be used to establish anonymised statistics about the browsing experience on our sites.
      </p>

      <h2>How do we use cookies?</h2>
      <p>
      Our website mostly uses “first-party cookies”. These are cookies set and controlled by us, not by any external organisation. However, to view some of our pages, you will have to accept cookies from external organisations.  
      </p>
      <p>
      These are set by us and only we can read them. They remember:
      If you have agreed to (or refused) this site’s cookie policy
      If you have already replied to our survey pop-up (about how helpful the site content was) – so you won't be asked again.
      </p>

      <br />
      <table>
        <tr>
          <th>Name</th>
          <th>Service</th>
          <th>Purpose</th>
          <th>Cookie type and duration</th>
        </tr>
        <tr>
          <td>__stripe_mid</td>
          <td>headstartcourses.ie</td>
          <td>This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.</td>
          <td>HTTP - 1 year</td>
        </tr>
        <tr>
          <td>__stripe_sid</td>
          <td>headstartcourses.ie</td>
          <td>This cookie is necessary for making credit card transactions on the website. The service is provided by Stripe.com which allows online transactions without storing any credit card information.</td>
          <td>HTTP - 1 day</td>
        </tr>
        <tr>
          <td>m</td>
          <td>m.stripe.com</td>
          <td>Determines the device used to access the website. This allows the website to be formatted accordingly.</td>
          <td>HTTP - 2 years</td>
        </tr>
      </table>
      <br />

      <p>
        There are some cookies that we have to include in order for certain web pages to function. For this reason, they do not require your consent. In particular:
        authentication cookies
        technical cookies required by certain IT systems
        authentication cookies
      </p>

      <p>
        These are stored when you log in to our website, using our authentication service (Login). When you do this, you accept the associated privacy policy.
      </p>

      <p>
        If you have any queries about Privacy Policy or Cookies, please, email us on: <a href = "mailto:bartira@headstartcourses.ie">bartira@headstartcourses.ie</a>.
      </p>

    </div>
  );
}

export default SecurityPolicy;